import iconStarFull from "assets/img/icon-star-full.svg"

import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import { Clamp, Guid } from "@/types"
import articleSidebars from "stores/articleSidebars"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import AssetService from "services/AssetService"
import Tooltip from "components/Tooltip/Tooltip"

interface IArticleDescriptionProps {
    articleDescription?: string
    articleId?: Guid
    assetId?: Guid
    highlight?: string
    isNodeArticle?: boolean
    withNodeArticleTooltip?: boolean
    clamp?: Clamp
    invalid?: boolean
}

const ArticleDescription: FunctionComponent<React.PropsWithChildren<IArticleDescriptionProps>> = ({
    articleDescription,
    articleId,
    assetId,
    highlight,
    isNodeArticle,
    withNodeArticleTooltip,
    clamp = 1,
    invalid,
}) => {
    const { t } = useTranslation()

    function handleClick() {
        if (!articleId && !assetId) return
        articleSidebars.show({
            articleId,
            getArticleId: assetId ? async () => {
                const asset = await AssetService.getAsset(assetId)
                return asset?.articleId || null
            } : undefined
        })
    }

    const nodeArticleIcon = <img src={iconStarFull} className="d-block" width="16" height="16" alt="" />

    return (
        <FlexibleContent
            text={articleDescription}
            highlight={highlight}
            onClick={articleId || assetId ? handleClick : undefined}
            className={invalid ? "color-red-600" : undefined}
            insertAfter={isNodeArticle
                ? (withNodeArticleTooltip
                    ? <Tooltip
                        trigger="hover"
                        content={isNodeArticle ? t('reservation.nodeArticleTooltip') : null}>
                        {nodeArticleIcon}
                    </Tooltip>
                    : nodeArticleIcon
                )
                : undefined
            }
            clamp={clamp}
        />
    )
}

export default ArticleDescription
